// extracted by mini-css-extract-plugin
export default {"main":"getMail_main__8fNvL","msg":"getMail_msg__yJNma"};